var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2625 9.58337C19.2625 10.5435 18.8163 11.7561 18.0316 13.1062C17.2594 14.4349 16.2176 15.7991 15.1573 17.038C14.0997 18.2735 13.0396 19.3659 12.2427 20.1502C11.9564 20.432 11.7047 20.6734 11.5 20.8668C11.2953 20.6734 11.0436 20.432 10.7573 20.1502C9.96038 19.3659 8.90031 18.2735 7.84275 17.038C6.78236 15.7991 5.74062 14.4349 4.96836 13.1062C4.18368 11.7561 3.7375 10.5435 3.7375 9.58337C3.7375 5.29626 7.21289 1.82087 11.5 1.82087C15.7871 1.82087 19.2625 5.29626 19.2625 9.58337Z",
    stroke: "#979AA8",
    strokeWidth: 1.725
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 9.2,
    r: 2.875,
    stroke: "#979AA8",
    strokeWidth: 1.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPoint);
export default __webpack_public_path__ + "static/media/map-point.3abe24a7323ca7d4b3e79c245e636f71.svg";
export { ForwardRef as ReactComponent };